import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchData(ctx, id) {
            return new Promise((resolve, reject) => {
              axios
                .get('/products/v1/block/getall/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        UpdateOrder(ctx, queryParams) {
            var data = JSON.stringify(queryParams.items);    
            return new Promise((resolve, reject) => {
              axios
                .put('/products/v1/block/updateOrdering' , data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        addBlock(ctx, queryParams) {
            return new Promise((resolve, reject) => {
              axios
                .post('/products/v1/block/add',queryParams)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateBlock(ctx, queryParams) {
            
            return new Promise((resolve, reject) => {
              axios
                .put('/products/v1/block/update/'+queryParams.id,queryParams.formData)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteBlock(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                  .delete('/products/v1/block/delete/'+id)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        },
        getBlockByContentId(ctx, id) {
            return new Promise((resolve, reject) => {
              axios
                .get(`/products/v1/block/get/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateOrdering(ctx, queryParams) {

            return new Promise((resolve, reject) => {
              axios
                .post('/products/v1/block/updateOrdering', queryParams)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}